import { PartitionReturnPivotPositionState } from "./PartitionReturnPivotPositionState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep";
import { IQuickSortContext } from "../../IQuickSortContext";

export class PartitionSwapPivotICountPlusState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionSwapPivotICount;

  Description = "Swap pivot with element at i index plus one";

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void { 
    if (this._context && this._context.ICount !== undefined && this._context.Hi !== undefined &&
        this._context.Numbers !== undefined && this._context.Pivot !== undefined) {
      
      let temp : number = this._context.Numbers[this._context.ICount + 1];
      this._context.Numbers[this._context.ICount + 1] = this._context.Numbers[this._context.Hi];
      this._context.Numbers[this._context.Hi] = temp;
    }
  }

  Undo(): void {
    if (this._context && this._context.ICount !== undefined && this._context.Hi !== undefined &&
      this._context.Numbers !== undefined && this._context.Pivot !== undefined) {
      
      let temp : number = this._context.Numbers[this._context.ICount + 1];
      this._context.Numbers[this._context.ICount + 1] = this._context.Numbers[this._context.Hi];
      this._context.Numbers[this._context.Hi] = temp;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      this._context.TransitionTo(new PartitionReturnPivotPositionState());
    }
  }
}